import { render, staticRenderFns } from "./DeclarationsStatistics.vue?vue&type=template&id=214236ec&scoped=true&"
import script from "./DeclarationsStatistics.vue?vue&type=script&lang=js&"
export * from "./DeclarationsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214236ec",
  null
  
)

export default component.exports